
<ng-lottie [options]="options" (animationCreated)="animationCreated($event)" style="display:flex;margin:0 auto;width:16%" class="anime_loader">
</ng-lottie>